/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import React from 'react'

/** A description of the available properties for this component. */
type InfoItemProps = {
  /** The icon to display at the start of the information item. */
  icon: React.ReactNode

  /** The label for the information item. */
  label: string

  /** The value for the information item. */
  value: React.ReactNode
}

/**
 * A single information item for an activity card. Displays an icon, label, and value.
 */
const ActivityCardInfoItem: React.FC<InfoItemProps> = ({ icon, label, value }) => (
  <li className={'flex items-center space-x-2'}>
    <span className={'w-8 h-8 flex items-center justify-center'}>{icon}</span>
    <span className={'text-gray-600 font-normal'}>{label}:</span>
    <span className={'text-gray-800'}>{value}</span>
  </li>
)

export { ActivityCardInfoItem }
